import styled from "styled-components";

export const StyledStatusBar = styled.div`
  width: 880px;
  display: flex;
  margin-bottom: 68px;
  height: 100px;
  background: #efeff7;
  border-radius: 2px;
`;

export const StatusSquare = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 220px;
  cursor: pointer;
  background: ${props => (props.active ? "#ffffff" : null)};
  border: ${props =>
    props.active ? "1px solid rgba(155, 155, 194, 0.3)" : null};
  border-radius: ${props => (props.active ? "2px" : null)};
  box-sizing: border-box;
`;

export const StatusIcon = styled.div`
  margin-right: 20px;
  width: 30px;
  min-width: 30px;

  svg {
    width: 30px;
    height: 24px;
  }
`;

export const SquareInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Qty = styled.div`
  margin-bottom: 4px;
  color: ${props => props.color};
  font-size: 28px;
  font-weight: 400;
  letter-spacing: 0.88px;
  line-height: 34px;
`;
export const Status = styled.div`
  color: #212530;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.75px;
  line-height: 14px;
`;
